import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-17fdc50f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "workspace"
};
const _hoisted_2 = {
  class: "icon"
};
const _hoisted_3 = {
  class: "workspace-content"
};
const _hoisted_4 = ["id"];
const _hoisted_5 = ["id"];
const _hoisted_6 = {
  class: "alert-count"
};
const _hoisted_7 = {
  class: "alert-popover"
};
const _hoisted_8 = {
  class: "header"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Alerts", -1));
const _hoisted_10 = {
  class: "total-alert"
};
const _hoisted_11 = {
  class: "alert-details"
};
const _hoisted_12 = {
  class: "alert-icon"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Urgent", -1));
const _hoisted_14 = {
  class: "alert-count"
};
const _hoisted_15 = {
  class: "alert-details"
};
const _hoisted_16 = {
  class: "alert-icon"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Alert", -1));
const _hoisted_18 = {
  class: "alert-count"
};
const _hoisted_19 = {
  class: "alert-details"
};
const _hoisted_20 = {
  class: "alert-icon"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Warning", -1));
const _hoisted_22 = {
  class: "alert-count"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_chevron_down_icon = _resolveComponent("chevron-down-icon");
  const _component_chevron_right_icon = _resolveComponent("chevron-right-icon");
  const _component_app_popover = _resolveComponent("app-popover");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_loading_element = _resolveComponent("loading-element");
  const _component_b_td = _resolveComponent("b-td");
  return _openBlock(), _createBlock(_component_b_td, {
    class: _normalizeClass(["portfolio-td-workspace", {
      'border-top': !$props.portfolio.collapsed && !$props.portfolio.seller_id,
      'border-left': !$props.portfolio.collapsed,
      'border-bottom': !$props.portfolio.collapsed && $props.portfolio.seller_id && $props.portfolio.isLastSellerInWorkspace,
      'border-radius-top-left': !$props.portfolio.collapsed && !$props.portfolio.seller_id,
      'border-radius-bottom-left': !$props.portfolio.collapsed && $props.portfolio.seller_id && $props.portfolio.isLastSellerInWorkspace
    }]),
    "sticky-column": ""
  }, {
    default: _withCtx(() => [_createVNode(_component_loading_element, {
      loading: $props.loading
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [!$props.portfolio.collapsed ? (_openBlock(), _createBlock(_component_chevron_down_icon, {
        key: 0,
        width: 16,
        height: 16
      })) : (_openBlock(), _createBlock(_component_chevron_right_icon, {
        key: 1,
        width: 16,
        height: 16
      }))]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: "workspace-name",
        id: _ctx.buildPortfolioTargetId($props.portfolio, 'name'),
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => $options.onWorkspaceNameClickHandler($props.portfolio.workspace_id), ["stop"]))
      }, [_createTextVNode(_toDisplayString($options.workspaceNameForBrandPortfolio($props.portfolio.workspace_id)) + " ", 1), _createVNode(_component_app_popover, {
        target: _ctx.buildPortfolioTargetId($props.portfolio, 'name'),
        placement: "top"
      }, {
        default: _withCtx(() => [_createTextVNode(" Open Workspace ")]),
        _: 1
      }, 8, ["target"])], 8, _hoisted_4), $props.portfolio.alerts_count ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "workspace-alert",
        id: _ctx.buildPortfolioTargetId($props.portfolio, 'alert'),
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => $options.onWorkspaceAlertClickHandler($props.portfolio.workspace_id), ["stop"]))
      }, [_createVNode(_component_app_icon, {
        icon: "brand-portfolio-alert"
      }), _createElementVNode("span", _hoisted_6, _toDisplayString($options.formatAlertCount($props.portfolio.alerts_count ?? 0)), 1), _createVNode(_component_app_popover, {
        target: _ctx.buildPortfolioTargetId($props.portfolio, 'alert'),
        placement: "top"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, _toDisplayString($options.formatAlertCount($props.portfolio.total_alert_count ?? 0)) + " Total ", 1)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_app_icon, {
          icon: "alert",
          color: "#DB333B"
        }), _hoisted_13]), _createElementVNode("span", _hoisted_14, _toDisplayString($options.formatAlertCount($props.portfolio.alert_count_level_1 ?? 0)), 1)]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createVNode(_component_app_icon, {
          icon: "alert",
          color: "#FF8933"
        }), _hoisted_17]), _createElementVNode("span", _hoisted_18, _toDisplayString($options.formatAlertCount($props.portfolio.alert_count_level_2 ?? 0)), 1)]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createVNode(_component_app_icon, {
          icon: "alert",
          color: "#F0C329"
        }), _hoisted_21]), _createElementVNode("span", _hoisted_22, _toDisplayString($options.formatAlertCount($props.portfolio.alert_count_level_3 ?? 0)), 1)])])]),
        _: 1
      }, 8, ["target"])], 8, _hoisted_5)) : _createCommentVNode("", true)])])]),
      _: 1
    }, 8, ["loading"])]),
    _: 1
  }, 8, ["class"]);
}